"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var React = _interopRequireWildcard(require("react"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ic_bracelet__active__dark(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "b557f43e-e4b0-4f74-ac57-4f891ef7e737",
    "data-name": "Icon",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 192 192"
  }, props), /*#__PURE__*/React.createElement("title", null, "bracelet-active-hi-dark"), /*#__PURE__*/React.createElement("g", {
    id: "1fc9bff3-5a48-4d96-9de0-799b9a558085",
    "data-name": "Apps_ic_hi"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M106.2,16h-5.9C62.64,16,32,46.35,32,83.65v24.7C32,145.65,62.64,176,100.3,176h5.9c29.67,0,53.8-23.9,53.8-53.29V69.29C160,39.9,135.87,16,106.2,16ZM140,126a30,30,0,0,1-30,30H98a30,30,0,0,1-30-30V66A30,30,0,0,1,98,36h12a30,30,0,0,1,30,30Z",
    transform: "translate(0 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.06
  }, /*#__PURE__*/React.createElement("path", {
    d: "M110,34H98A30,30,0,0,0,68,64v2A30,30,0,0,1,98,36h12a30,30,0,0,1,30,30V64A30,30,0,0,0,110,34Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.2,174h-5.9C62.64,174,32,143.65,32,106.35v2C32,145.65,62.64,176,100.3,176h5.9c29.67,0,53.8-23.9,53.8-53.29v-2C160,150.1,135.87,174,106.2,174Z",
    transform: "translate(0 0)"
  })), /*#__PURE__*/React.createElement("rect", {
    width: 192,
    height: 192,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50,102a6,6,0,1,1,6-6A6,6,0,0,1,50,102Z",
    transform: "translate(0 0)",
    fill: "#e60000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50,100a6,6,0,0,1-5.91-5A6.64,6.64,0,0,0,44,96a6,6,0,0,0,12,0,6.64,6.64,0,0,0-.09-1A6,6,0,0,1,50,100Z",
    transform: "translate(0 0)",
    opacity: 0.12
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.93,64.09c0,.64.07,1.27.07,1.91v60c0,.64,0,1.28-.07,1.91A5,5,0,0,0,72,123V69A5,5,0,0,0,67.93,64.09Z",
    transform: "translate(0 0)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.93,64.09c0,.64.07,1.27.07,1.91v60c0,.64,0,1.28-.07,1.91A5,5,0,0,0,72,123V69A5,5,0,0,0,67.93,64.09Z",
    transform: "translate(0 0)",
    opacity: 0.06
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40,51.92a66.71,66.71,0,0,0-8,31.73v24.7a66.71,66.71,0,0,0,8,31.73Z",
    transform: "translate(0 0)",
    opacity: 0.06
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36,60.86a66.75,66.75,0,0,0-4,22.79v24.7a66.75,66.75,0,0,0,4,22.79Z",
    transform: "translate(0 0)",
    fill: "#4a4d4e"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.06
  }, /*#__PURE__*/React.createElement("polyline", {
    points: "139.94 94.02 159.99 94.02 160 98.02 140 98.02"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 140,
    y: 98,
    width: 20,
    height: 2,
    fill: "#4a4d4e"
  })));
}

var _default = ic_bracelet__active__dark;
exports.default = _default;